module.exports = __webpack_public_path__ + "static/img/empty-catalog-table.e5e717d3.svg";